import React, { useEffect, useRef } from "react";
import { Card, Button, Space, Dropdown, Flex, Select, Form, notification, Modal } from "antd";
import {
    ThunderboltOutlined,
    ClockCircleOutlined,
    EditOutlined,
    PlusOutlined,
    ScheduleOutlined,
    DeleteOutlined,
    LeftOutlined,
    ArrowLeftOutlined,
} from "@ant-design/icons";
import LineConnector from "./LineConnector";
import LeadFilterForm from "./Cards/LeadForm";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { postData, putData } from "../../actions/developer";
import { deleteRow, getData } from "../../actions/apiCall";
import FormSetup from "../../components/Forms/FormSetup";
import { MasterConfigs } from "../../interfaces/entity";
import RuleTriggerTimeForm from "./ScheduleForm";

const WorkflowUI = () => {
    const [conditons, setConditions] = React.useState([])
    const [drawLines, setDrawLines] = React.useState([])
    const [rerender, setRerender] = React.useState(null)
    const [editWhen, setEditWhen] = React.useState(false)
    const [whenCondition, setWhenCondition] = React.useState('')
    const [instructions, setInstructions] = React.useState({})
    const [addMoreCondition, setAddMoreCondition] = React.useState(false)
    const [payload, setPayload] = React.useState(null)
    const [form] = Form.useForm();
    const [instantAction, setInstantAction] = React.useState({})
    const [selectedInstruction, setSelectedInstruction] = React.useState(null)

    const refs = useRef<Record<string, HTMLDivElement | null>>({});
    const containerRef = useRef<HTMLDivElement | null>(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const { id } = useParams()
    const queryParams = new URLSearchParams(window.location.search);
    const moduleName = queryParams.get('module')

    if (!moduleName) {
        navigate(-1)
    }

    useEffect(() => {
        if (id) {
            getWhenData()
            getConditionsData()
        }
    }, [id])

    useEffect(() => {
        if (conditons.length > 0) {
            console.log(conditons)
            conditons.find((ele) => ele.conditionType == 'all' || ele.conditionType == 'not_matching_condition') ? setAddMoreCondition(false) : setAddMoreCondition(true)
        }
    }, [conditons])

    const onWhenSave = async (values) => {
        try {
            setEditWhen(false)
            const resData = await dispatch(putData(`/work-flow/${id}`, values))
            if (resData) {
                if (conditons.length == 0) {
                    onAddCondition()
                }
                getWhenData()
            }
        } catch (error) {
            console.error("Error saving when condition:", error);
            notification.error({
                message: "Error",
                description: "Failed to save the when condition. Please try again.",
            });
        }
    }

    const getWhenData = async () => {
        const resData = await dispatch(getData(`/work-flow/${id}`))
        if (resData.code == 200) {
            setWhenCondition(resData.data.executeOn)
            if (!resData.data.executeOn) {
                setEditWhen(true)
            } else {
                form.setFieldsValue({ executeOn: resData.data.executeOn })
                setEditWhen(false)
            }
        }
    }

    const getConditionsData = async () => {
        const resData = await dispatch(getData(`/work-flow-condition`, { workFlow: id }));
        if (resData.code == 200) {
            resData.data.sort((a, b) => a.order - b.order)
            setConditions(resData.data.map((ele) => ele))
            const actionData = await dispatch(getData(`/work-flow-action`, { workFlow: id }));
            if (actionData) {
                const inst = actionData.data.sort((a, b) => a.order - b.order).filter((ele) => ele.actionType == 'Scheduled').reduce((acc, ele) => {
                    if (!acc[ele.condition]) {
                        acc[ele.condition] = [];
                    }
                    acc[ele.condition].push(ele);
                    return acc;
                }, {});
                setInstructions(inst)
                const instantAction = actionData.data.filter((ele) => ele.actionType == 'Instants').reduce((acc, ele) => {
                    if (!acc[ele.condition]) {
                        acc[ele.condition] = [];
                    }
                    acc[ele.condition].push(ele);
                    return acc;
                }, {});
                setInstantAction(instantAction)
            }
        }
    }

    const onAddCondition = async () => {
        const resData = await dispatch(postData(`/work-flow-condition`, { workFlow: id, conditionName: conditons.length + 1 }));
        if (resData.code == 200) {
            await dispatch(postData(`/work-flow-action`, { workFlow: id, condition: resData.data._id }));
            await dispatch(postData(`/work-flow-action`, { workFlow: id, condition: resData.data._id, actionType: 'Scheduled' }));
            getConditionsData()
        }
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDrawLines(conditons);
            setRerender({ conditons, instructions, instantAction });
        }, 100);

        return () => clearTimeout(timeout);
    }, [conditons, instructions, instantAction])

    const drawLinesFor = () => {
        return drawLines.flatMap((ele, index) => {
            const currentInsts = instructions[ele?._id] || [];

            const baseLines = [
                ...(index === 0
                    ? [
                        <LineConnector key={`when-${ele?.conditionName}`} fromRef={{ current: refs.current['when'] }} toRef={{ current: refs.current[`condition_${ele?.conditionName}`] }} containerRef={containerRef} />,
                    ]
                    : [
                        <LineConnector key={`cond-${drawLines[index - 1]?.conditionName}-${ele?.conditionName}`} fromRef={{ current: refs.current[`condition_${drawLines[index - 1]?.conditionName}`] }} toRef={{ current: refs.current[`condition_${ele?.conditionName}`] }} containerRef={containerRef} />,
                    ]),
                <LineConnector key={`cond-card-${ele?.conditionName}`} fromRef={{ current: refs.current[`condition_${ele?.conditionName}`] }} toRef={{ current: refs.current[`condition_card_${ele?.conditionName}`] }} containerRef={containerRef} />,
                <LineConnector key={`card-inst-${ele?.conditionName}`} fromRef={{ current: refs.current[`condition_card_${ele?.conditionName}`] }} toRef={{ current: refs.current[`instuctions_${ele?._id}`] }} containerRef={containerRef} />,
            ];

            const scheduleLines =
                currentInsts.length > 0
                    ? [
                        <LineConnector key={`inst-first-${ele?._id}`} fromRef={{ current: refs.current[`instuctions_${ele?._id}`] }} toRef={{ current: refs.current[`schedule_${ele?._id}_${currentInsts[0]._id}`] }} containerRef={containerRef} />,
                        ...currentInsts.slice(0, -1).map((inst, i) => {
                            const next = currentInsts[i + 1]._id;
                            return (
                                <LineConnector
                                    key={`sched-${ele?._id}-${inst._id}-to-${next}`}
                                    fromRef={{ current: refs.current[`schedule_${ele?._id}_${inst._id}`] }}
                                    toRef={{ current: refs.current[`schedule_${ele?._id}_${next}`] }}
                                    containerRef={containerRef}
                                />
                            );
                        }),
                    ]
                    : [];

            return [...baseLines, ...scheduleLines];
        });
    }

    const addAction = async (ele, conditionId, type) => {
        try {
            setPayload({
                workFlow: id,
                condition: ele._id,
                actionType: type,
                scheduleType: 'email',
                scheduleStatus: type == 'Scheduled' ? 'active' : 'inactive',
                emailTemplate: 'email_template',
            })
        } catch (error) {
            notification.error({
                message: "Error",
                description: "Failed to save the when condition. Please try again.",
            });
        }
    }

    const deleteInstruction = async (instructionId) => {
        try {
            const resData = await dispatch(deleteRow(`/work-flow-action/${instructionId}`));
            if (resData) {
                // delete all conditions for this instruction
                getConditionsData()
            }
        }
        catch (error) {
            console.error("Error saving when condition:", error);
            notification.error({
                message: "Error",
                description: "Failed to save the when condition. Please try again.",
            });
        }
    }

    const deleteCondition = async (conditionId) => {
        Modal.confirm({
            type: 'confirm',
            title: 'Are you sure you want to delete this?',
            onOk: async () => {
                try {
                    const resData = await dispatch(deleteRow(`/manage/workflow/conditions/${conditionId}`));
                    if (resData) {
                        getConditionsData()
                    }
                }
                catch (error) {
                    console.error("Error saving when condition:", error);
                    notification.error({
                        message: "Error",
                        description: "Failed to save the when condition. Please try again.",
                    });
                }
            },
            onCancel: () => {
                console.log('Cancel');
            }
        });
    }

    const submitData = async (values) => {
        try {
            if (!selectedInstruction) {
                return
            }
            const resData = await dispatch(putData(`/work-flow-action/${selectedInstruction}`, values));
            if (resData) {
                if ('Scheduled' == values.actionType) {
                    await dispatch(postData(`/manage/workflow/schedule`, { workFlow: id, condition: values.condition, actionType: 'Scheduled' }));
                }
                setPayload(null)
                setSelectedInstruction(null)
                getConditionsData()
                return { code: 200 }
            } else {
                return { code: 400 }
            }
        } catch (error) {
            console.error("Error saving when condition:", error);
            notification.error({
                message: "Error",
                description: "Failed to save the when condition. Please try again.",
            });
            return { code: 400 }
        }
    }

    const items = [
        {
            key: 'email_notification',
            label: 'Email Notification',
        },
    ];

    const config: MasterConfigs = {
        api: () => 'email-template',
        modalTitle: () => 'Email Template',
        onSubmit: async (id, values) => {
            return await submitData({ ...payload, emailTemplate: values?.email_template })
        },
        getFormColumns: () => [
            {
                name: 'email_template',
                label: 'Email Template',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select an email template' }],
                placeholder: 'Select Email Template',
            },
        ],
        combo: [
            {
                api: '/cms/emailTemplates',
                name: 'email_template',
                idKey: '_id',
                render: (e) => e.name
            }
        ]
    }

    return (
        <div className="p-10 bg-[#e5e8f3]">
            <FormSetup open={payload} onClose={() => setPayload(null)} config={config} isModal={true} />
            <div className="flex justify-between mb-10">
                <div>

                    <Flex justify="start" align="center" gap={5}>
                        <ArrowLeftOutlined className="!text-xl hover:text-blue-600 hover:-translate-x-1 transition-transform duration-300" onClick={() => navigate(-1)} />
                        <h1 className="text-xl font-semibold">Workflow Rules</h1>
                    </Flex>
                    <p className="text-sm text-gray-500">Create a workflow rule to automate your processes.</p>
                </div>
                <div className="flex justify-end gap-4">
                    <Button danger>Cancel</Button>
                    <Button type="primary">Save</Button>
                </div>
            </div>

            <div className="relative min-h-screen" ref={containerRef}>
                <div className="z-10">
                    <div className="relative flex flex-col gap-20">
                        <div className="flex gap-20 items-center">
                            <div ref={(node) => refs.current['when'] = node} data-anchor="center" className="z-10 w-20 h-20 rounded-full bg-[#1a3d9f] text-white flex items-center justify-center font-bold text-sm">
                                WHEN
                            </div>
                            <Card className="w-[500px] z-10 group" ref={(node) => refs.current['whenCard'] = node} data-anchor="center">
                                {!editWhen && <Button type="text" className="absolute top-2 right-2 group-hover:block hidden" onClick={() => setEditWhen(true)} >
                                    <EditOutlined />
                                </Button>}
                                {!editWhen ? <div>
                                    {whenCondition == 'create_edit' && <>This rule will be executed when a {moduleName} is <b>created</b> or is <b>edited</b> to meet the condition (if any)</>}
                                    {whenCondition == 'create' && <>This rule will be executed when a {moduleName} is <b>created</b> to meet the condition (if any)</>}
                                    {whenCondition == 'edit' && <>This rule will be executed when a {moduleName} is <b>edited</b> to meet the condition (if any)</>}
                                    {whenCondition == 'delete' && <>This rule will be executed when a {moduleName} is <b>deleted</b> to meet the condition (if any)</>}
                                </div> :
                                    <>
                                        <div className="flex gap-4">
                                            <div>
                                                Execute this workflow rule based on
                                            </div>
                                            <Form form={form} onFinish={(values) => onWhenSave(values)}>
                                                <Form.Item name="executeOn"
                                                    className="w-50"
                                                    rules={[{ required: true, message: 'Please select a module' }]}>
                                                    <Select className="w-50" placeholder="Select a module" >
                                                        <Select.Option value="create">Create</Select.Option>
                                                        <Select.Option value="create_edit">Create Or Edit</Select.Option>
                                                        <Select.Option value="edit">Edit</Select.Option>
                                                        {/* <Select.Option value="delete">Delete</Select.Option> */}
                                                    </Select>
                                                </Form.Item>
                                            </Form>
                                        </div>
                                        <div className="flex justify-end mt-10">
                                            <Button type="primary" onClick={() => form.submit()}>
                                                Save
                                            </Button>
                                        </div>
                                    </>
                                }
                            </Card>
                        </div>
                        <LineConnector key={`whenCard`} fromRef={{ current: refs.current['when'] }} toRef={{ current: refs.current['whenCard'] }} containerRef={containerRef} />
                        <div className="flex flex-col gap-10">
                            {conditons.map((ele, index) => <div key={ele?.conditionName} className="flex gap-20">
                                <div className="flex flex-col">
                                    <div
                                        ref={(node) => refs.current[`condition_${ele?.conditionName}`] = node}
                                        data-anchor="center"
                                        style={{ transform: 'rotate(-45deg)' }}
                                        className="z-10 w-20 h-20 rounded-md bg-[#1a3d9f] p-4  flex items-center justify-center text-center "
                                    >
                                        <div style={{ transform: 'rotate(45deg)' }} className="!text-sm font-bold text-white">
                                            Condition <br />{ele?.conditionName}
                                        </div>
                                    </div>

                                    {conditons.length == index + 1 && addMoreCondition && <div className="mt-20 text-left">
                                        <Button
                                            type="link"
                                            size="small"
                                            className="p-0 -m-4"
                                            onClick={() => onAddCondition()}
                                        >
                                            <span className="font-medium flex items-center gap-2 w-4 !break-words">
                                                <PlusOutlined className="!text-lg" /> Add Another <br />
                                                Condition
                                            </span>
                                        </Button>
                                    </div>}
                                </div>
                                <div className="flex flex-col gap-10 w-full">
                                    <Card className="max-w-5xl rounded-md bg-white z-10 group relative">
                                        <div className="w-5 h-7" ref={(node) => refs.current[`condition_card_${ele?.conditionName}`] = node} data-anchor="center"></div>
                                        {index > 0 && <Button type="text" className="absolute top-2 right-2 group-hover:block hidden"
                                            onClick={() => deleteCondition(ele._id)}
                                            danger
                                            icon={<DeleteOutlined />}
                                        />}
                                        <LeadFilterForm key={ele._id} condition={ele._id} conditionIndex={index} reload={() => getConditionsData()} />
                                    </Card>
                                    <Space direction="horizontal" align="start" className="z-10 gap-20">
                                        {instantAction[ele?._id]?.map((inst, ind) => <div key={ind} className="w-[260px] bg-white flex flex-col justify-between z-10 rounded-md"
                                            ref={(node) => (refs.current[`instuctions_${ele?._id}`] = node)}
                                            data-anchor="top"
                                            data-from={"right"}
                                        >
                                            <div className="p-4">
                                                <span className="text-[#1a3d9f] font-medium flex items-center gap-2">
                                                    <ThunderboltOutlined className="!text-lg" /> Instant Actions
                                                </span>
                                                {inst.emailTemplate?.name && <div className="flex flex-col gap-2 mt-4">
                                                    <div key={ind} className="flex justify-between items-center">
                                                        <p className="text-sm">[{inst?.scheduleType}] {inst.emailTemplate?.name}</p>
                                                    </div>
                                                </div>}
                                            </div>
                                            <Dropdown
                                                menu={{
                                                    items, onClick: (e) => {
                                                        setSelectedInstruction(inst._id)
                                                        addAction(ele, e.key, 'Instants')
                                                    }
                                                }}
                                                trigger={['click']}
                                            >
                                                <div className="bg-blue-100 p-2 hover:bg-blue-200 cursor-pointer">
                                                    <p className="link text-[#1a3d9f] !font-medium">
                                                        <PlusOutlined className="!text-sm" />{" "}Add Action
                                                    </p>
                                                </div>
                                            </Dropdown>
                                        </div>)}
                                        <div className="flex flex-col gap-10">
                                            {instructions[ele?._id]?.map((inst, ind) => (
                                                <div
                                                    key={ind}
                                                    className="w-[500px] border z-10 bg-white rounded-md group relative"
                                                    ref={(node) => (refs.current[`schedule_${ele?._id}_${inst._id}`] = node)}
                                                    data-anchor={ind === 0 ? "left" : "center"}
                                                    data-from={"center"}
                                                >
                                                    <div className="p-4 w-full">
                                                        {ind > 0 && <Button type="link"
                                                            onClick={() => {
                                                                Modal.confirm({
                                                                    type: 'confirm',
                                                                    title: 'Are you sure you want to delete this?',
                                                                    onOk: () => {
                                                                        deleteInstruction(inst._id)
                                                                    },
                                                                    onCancel: () => {
                                                                        console.log('Cancel');
                                                                    }
                                                                });
                                                            }}
                                                            className="absolute top-2 right-2 group-hover:block hidden"
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                        />}

                                                        <span className="text-[#1a3d9f] font-medium flex items-center gap-2">
                                                            <ScheduleOutlined className="!text-lg" /> Schedule Actions
                                                        </span>
                                                        <div className="w-full">
                                                            <RuleTriggerTimeForm key={inst._id} data={inst} reload={() => getConditionsData()} />
                                                        </div>
                                                        {inst.emailTemplate?.name && <div key={ind} className="flex justify-between items-center">
                                                            <p className="text-sm">[{inst?.scheduleType}] {inst.emailTemplate?.name}</p>
                                                        </div>}
                                                    </div>
                                                    {inst?.scheduleTime > 0 && <Dropdown
                                                        menu={{
                                                            items, onClick: (e) => {
                                                                setSelectedInstruction(inst._id)
                                                                addAction(ele, e.key, 'Scheduled')
                                                            }
                                                        }}
                                                        trigger={['click']}
                                                    >
                                                        <div className="bg-blue-100 p-2 hover:bg-blue-200 cursor-pointer" >
                                                            <p className="link text-[#1a3d9f] !font-medium">
                                                                <PlusOutlined className="!text-sm" />{" "}Add Action
                                                            </p>
                                                        </div>
                                                    </Dropdown>}
                                                </div>
                                            ))}
                                        </div>
                                    </Space>
                                </div>
                            </div>
                            )}
                        </div>
                        {rerender && drawLinesFor()}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default WorkflowUI;
